var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.5C9 7.42969 7.42969 9 5.5 9C3.57031 9 2 7.42969 2 5.5C2 3.57031 3.57031 2 5.5 2C7.42969 2 9 3.57031 9 5.5ZM13 12C13 11.7344 12.8906 11.4766 12.7109 11.2969L10.0312 8.61719C10.6641 7.70312 11 6.60938 11 5.5C11 2.46094 8.53906 0 5.5 0C2.46094 0 0 2.46094 0 5.5C0 8.53906 2.46094 11 5.5 11C6.60938 11 7.70312 10.6641 8.61719 10.0312L11.2969 12.7031C11.4766 12.8906 11.7344 13 12 13C12.5469 13 13 12.5469 13 12Z",
    fill: "#C4C4C4"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.2c3a2fff.svg";
export { ForwardRef as ReactComponent };